import dynamic from 'next/dynamic';

import { ButtonBlockProps, ButtonTextColorMode } from 'src/components/blocks/ButtonBlock';
import { ContentBlockRenderer } from 'src/types/Block';
import { Transformer } from 'src/types/Transformer';
import { ButtonSectionContent } from './types';

/* istanbul ignore next */
export const renderer: ContentBlockRenderer<ButtonBlockProps> = dynamic<ButtonBlockProps>(() =>
  import('src/components/blocks/ButtonBlock').then((mod) => mod.ButtonBlock),
);

export const transformer: Transformer<ButtonSectionContent, ButtonBlockProps> = ({
  _metadata,
  background_color,
  text_color_mode,
  text,
  href,
  tracking_title,
}) => ({
  uid: _metadata.uid,
  props: {
    customBackgroundColor: background_color,
    textColorMode: text_color_mode as ButtonTextColorMode,
    href,
    children: text,
    trackingTitle: tracking_title,
  },
});
